// extracted by mini-css-extract-plugin
export var accountMenu = "SessionButtons-module--account-menu--8313c";
export var loginSignupButtons = "SessionButtons-module--login-signup-buttons--977e0";
export var signUpButton = "SessionButtons-module--sign-up-button--e53b5";
export var spinner = "SessionButtons-module--spinner--13dcf";